//Reset data
export const RESET = "CHAT_DEL_RESET"



//Loading
export const SET_TOGGLE_LOADING = "CHAT_DEL_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "CHAT_DEL_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "CHAT_DEL_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "CHAT_DEL_SET_MESSAGE"
export const SET_IS_SUCCESS = "CHAT_DEL_SET_IS_SUCCESS"
export const SET_IS_ERROR = "CHAT_DEL_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "CHAT_DEL_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "CHAT_DEL_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "CHAT_DEL_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "CHAT_DEL_SET_ITEMS"
export const SET_CURRENT_ITEM = "CHAT_DEL_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "CHAT_DEL_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "CHAT_DEL_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "CHAT_DEL_SET_HIDE_MODAL"


export const SET_MODAL = "CHAT_DEL_SET_MODAL"
export const SET_MODAL_CONTENT = "CHAT_DEL_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "CHAT_DEL_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "CHAT_DEL_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "CHAT_DEL_SET_MODAL_TYPE"
export const SET_MODAL_IS_UPDATE = "CHAT_DEL_SET_IS_UPDATE"